module.exports = __webpack_public_path__ + "assets/img/img-entry-bg.61e71cc7.jpg";